<template>
<!-- height: picking === false ? `${sticks.length*55.4285714286}px` : 'auto' -->
  <div class="stick-cup-contain" 
  :style="{height: picking === false ? `${sticks.length*55.4285714286}px` : 'auto', 
  overflow: picking === false ? 'hidden' : 'visible'}" 
  ref="sticksCupContain">
    <div class="stick-parent" :class="{'shuffle' : shuffleSticks, 'reset' : resetSticks}" :style="{height: parentH}" ref="stickParent" :key="parentKey">
  
      <transition-group name="sticks" tag="div" :duration="1000">
        <div v-for="(stick, index) in sticks" :key="stick.id" class="stick" :class="{'picked' : stick.picked===true, 'chosen' : choice === index}" :style="{
          top: stickPosArr[index]+'px', 
          transform: 'rotate('+stickRotArr[index]+'deg)'
          }">
    
            <input type="text" v-model="stick.choice" :placeholder="'Choice ' + (index+1)" :readonly="picking!==false" />
    
            <span v-if="sticks.length>=3 && picking===false" class="remove" v-on:click="remove(index)" title="remove">&times;</span>
    
        </div>
      </transition-group>

      
      <div class="cup" :class="{'active' : shuffleSticks}" :key="shuffleSticks">
        <img :src="`/cups/${cup}.png`" alt="cup">
      </div>
    
    </div>
  </div>
</template>


<script>
export default {
  name: 'Sticks',
  props: {
    sticks: Array,
    choice: {
      type:[Number, Boolean],
      default: false
    },
    picking: [String, Boolean],
    cup: {
      type: String,
      default: 'cup'
    },
  },
  data() {
    return {
      shuffleSticks: false,
      resetSticks: false,
      reveal: false,
      stickPosArr: [],
      ogPosArr: [],
      stickRotArr:[],
      parentH: 'auto',
      parentKey: 1,
    }
  },
  methods: {
    shuffle(){
      const allSticks = document.querySelectorAll('.stick');
      this.stickPosArr.fill(0);
      const self = this;
      [...allSticks].forEach((stick,index) => {
        let rotateRaw = Math.round(Math.random() * 8)
        self.stickRotArr[index] = Math.round(Math.random() * 2) == 1 ? rotateRaw : rotateRaw*-1;
      })
      this.parentH = `72px`;
      this.shuffleSticks = true
    },
    reset(){
      const allSticks = document.querySelectorAll('.stick');
      const self = this;
      this.parentH = `${allSticks.length * 50.667 + 10}px`;
      this.shuffleSticks = false;
      this.resetSticks = true;
      this.stickPosArr = this.ogPosArr;
      [...allSticks].forEach((stick,index) => {
      self.stickRotArr[index] = 0;
      })
      setTimeout(() => {
        this.resetSticks = false
        this.parentH = 'auto'
      }, 1000);
    },
    remove(index){ this.$emit('remove', index); }
  },
  watch: {
    choice: async function () {
      const allSticks = document.querySelectorAll('.stick');
      const self = this;

      if(this.choice === false) return

      const parentH = this.$refs.stickParent.clientHeight;
      this.parentH = `${parentH}px`;

      [...allSticks].forEach((stick,index) => {
        self.stickPosArr[index] = stick.offsetTop - 10;
      })


      this.ogPosArr = [...this.stickPosArr]
      
      setTimeout(() => {
        self.shuffle();
      }, 1000);
      setTimeout(() => {
        self.$emit('picked');
      }, 6000);
    },
    picking: function(){
      if(this.picking === 'reset') this.reset()
    },
  },
}
</script>


<style lang="scss">

.stick {
      width:320px;
      height:44px;
      margin:10px auto;
      padding:2px 30px 2px 10px;
      background: transparent url('../assets/stick1.jpg') no-repeat center center;
      background-size: contain;
      border-radius:20px;
      display: flex;
      align-items: center;

      input { 
        border: none;
        background: transparent;
        color: rgba(0,0,0,0.9);
        width: 100%;
        line-height:40px;
        height:40px;
        font: bold 24px/40px 'Gaegu', cursive, sans-serif;
        outline: none;
      }
      .remove {
        display: block;
        font:normal 20px/16px Arial,sans-serif;
        width:20px;
        height:20px;
        border-radius:10px;
        color: rgba(0,0,0,0.6);
        border:solid 2px rgba(0,0,0,0.6);
        cursor: pointer;
        flex: 0 0 20px;
        &:hover { color: rgba(255,0,0,0.9); border-color: rgba(255,0,0,0.9); }
      }
      &.picked {
        background-image: url('../assets/stick1g.jpg');
        input { pointer-events: none; }
        
      }
    }

.stick-cup-contain{
    transition: all 250ms;
}
.stick-parent{
    position: relative;
    width: 320px;
    margin: 10px auto;



    &.shuffle{
      
      .stick{
        animation: shuffle 4s 1.1s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        position: absolute;
        // top: 0 !important;

        &.chosen{
          opacity: 1 !important;
          animation: setChoice 4s 1.1s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
        }
      }
    }

    &.reset{
      .stick{
        position: absolute;
        top: 0;
        transition: all 1s;
        opacity: 1;
        z-index: 1;

        &.chosen{
          z-index: 5;
          opacity: 1 !important;
        }
      }
    }
  }

  .cup{
    opacity: 0;
    z-index: 10;
    display: none;
    &.active{
      animation: cup 4s 1.1s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      opacity: 0;
      display: block;
      position: relative;
      padding-bottom: 100px;
      &:after {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 400px;
        border-radius: 80px;
        background: #fff;
        display: block;
        content: ' ';
        z-index: 1;
      }
    }

    img{
      width: 100%;
      display: block;
      position: relative;
      z-index: 2;
      transform: scaleX(-1);
    }
  }

  @keyframes setChoice {
    20%{
      transform: rotate(90deg);
    }

    30%{
      transform: rotate(90deg) translateX(50%);
    }

    50%{
      transform: rotate(90deg) translateX(50%);
    }

    90%{
      z-index: 5;
      opacity: 1;
    }

    100%{
      transform: rotate(0deg) translateX(0%);
    }
  }

  @keyframes shuffle {
    20%{
      transform: rotate(90deg);
    }

    30%{
      transform: rotate(90deg) translateX(50%);
    }

    50%{
      transform: rotate(90deg) translateX(50%);
    }

    79%{
      opacity: 1;
    }

    90%{
      opacity: 0;
    }

    100%{
      transform: rotate(0deg) translateX(0%);
      opacity: 0;
    }
  }

  @keyframes cup{
    0%{
      transform: translateY(300px);
      opacity: 0;
    }

    10%{
      opacity: 1;
    }

    30%{
      transform: translateY(0);
    }

    35%{
      transform: rotate(20deg)
    }

    36%{
      transform: rotate(20deg)
    }

    37%{
      transform: rotate(-20deg)
    }

    38%{
      transform: rotate(20deg)
    }
    39%{
      transform: rotate(-20deg)
    }
    40%{
      transform: rotate(20deg)
    }
    41%{
      transform: rotate(-20deg)
    }
    42%{
      transform: rotate(20deg)
    }
    43%{
      transform: rotate(-20deg)
    }
    44%{
      transform: rotate(20deg)
    }
    45%{
      transform: rotate(-20deg)
    }

    50%{
      transform: rotate(0deg);
      opacity: 1;
    }

    75%{
      transform: translateY(300px);
    }

    90%{
      opacity: 1;
    }


  100%{
      transform: translateY(300px);
      opacity: 0;
    }
  }



.stick{
  transition: all 1s;
}

.sticks-enter{
  opacity: 0;
  transform: scale(0);
}

.sticks-leave-to{
  opacity: 0;
  transform: scale(0.01);
}

.sticks-leave-active {
  position: absolute;
  z-index: -1;
}

</style>